import React from 'react'
import Alert from 'mz-ui-kit/core/Alert'
import moment from 'moment'

const NoPickupAlert = ({ tripStatus }) => {
  return (
    <Alert color="RED">
      No Pickup: {moment(tripStatus.timestamp).format('dddd MMMM D YYYY HH:mm')}
    </Alert>
  )
}

export default NoPickupAlert
